"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Stack = void 0;
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var StackItem_1 = require("../StackItem");
exports.Stack = react_1.default.forwardRef(function (_a, ref) {
    var _b;
    var children = _a.children, className = _a.className, _c = _a.vertical, vertical = _c === void 0 ? false : _c, _d = _a.spacing, spacing = _d === void 0 ? 0 : _d, _e = _a.distribution, distribution = _e === void 0 ? 'leading' : _e, _f = _a.alignment, alignment = _f === void 0 ? 'fill' : _f, _g = _a.nowrap, nowrap = _g === void 0 ? false : _g, _h = _a.wrap, wrap = _h === void 0 ? 'nowrap' : _h, _j = _a.direction, direction = _j === void 0 ? 'row' : _j, _k = _a.justifyContent, justifyContent = _k === void 0 ? 'flex-start' : _k, _l = _a.alignItems, alignItems = _l === void 0 ? 'stretch' : _l, _m = _a.alignContent, alignContent = _m === void 0 ? 'stretch' : _m, rest = __rest(_a, ["children", "className", "vertical", "spacing", "distribution", "alignment", "nowrap", "wrap", "direction", "justifyContent", "alignItems", "alignContent"]);
    react_1.default.useEffect(function () {
        if (nowrap) {
            console.warn('@servicetitan/design-system: The `nowrap` prop of the Stack component has been deprecated. Please use `wrap` instead.');
        }
        if (alignment !== 'fill') {
            console.warn('@servicetitan/design-system: The `alignment` prop of the Stack component has been deprecated. Please use `alignItems` instead.');
        }
        if (distribution !== 'leading') {
            console.warn('@servicetitan/design-system: The `distribution` prop of the Stack component has been deprecated. Please use `justifyContent` instead.');
        }
        if (vertical) {
            console.warn('@servicetitan/design-system: The `vertical` prop of the Stack component has been deprecated. Please use `direction` instead.');
        }
    });
    var getFlexWrap = function () {
        if (nowrap)
            return 'wrap';
        return wrap;
    };
    var getFlexDirection = function () {
        if (vertical)
            return 'column';
        return direction;
    };
    var getFlexJustifyContent = function () {
        var justificationConverter = {
            leading: 'flex-start',
            trailing: 'flex-end',
            center: 'center',
            equalSpacing: 'space-between',
        };
        if (distribution !== 'leading')
            return justificationConverter[distribution];
        return justifyContent;
    };
    var getFlexAlignItems = function () {
        var alignmentConverter = {
            leading: 'flex-start',
            trailing: 'flex-end',
            center: 'center',
            fill: 'stretch',
            baseline: 'baseline',
        };
        if (alignment !== 'fill')
            return alignmentConverter[alignment];
        return alignItems;
    };
    var realWrap = getFlexWrap();
    var realDirection = getFlexDirection();
    var realJustifyContent = getFlexJustifyContent();
    var realAlignItems = getFlexAlignItems();
    var StackClasses = classnames_1.default('Stack', className);
    var StackWrapperClasses = classnames_1.default('Stack__InternalWrapper', (_b = {},
        _b["Stack--spacing-" + spacing] = spacing,
        _b["Stack--wrap-" + realWrap] = realWrap,
        _b["Stack--direction-" + realDirection] = realDirection,
        _b["Stack--justify-content-" + realJustifyContent] = realJustifyContent,
        _b["Stack--align-items-" + realAlignItems] = realAlignItems,
        _b["Stack--align-content-" + alignContent] = alignContent,
        _b));
    return (react_1.default.createElement("div", __assign({ className: StackClasses, ref: ref }, rest),
        react_1.default.createElement("div", { className: StackWrapperClasses }, children)));
});
exports.Stack.Item = StackItem_1.StackItem;
//# sourceMappingURL=Stack.js.map